import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Backdrop, Card, CardContent, CardHeader, Divider, Input, List, ListItem,
  ListItemAvatar, ListItemSecondaryAction, ListItemText, Paper, Typography,
  CircularProgress, Box, Chip, Avatar
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { green, amber, blueGrey } from '@material-ui/core/colors';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import SearchIcon from '@material-ui/icons/Search';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import PhoneCallbackIcon from '@material-ui/icons/PhoneCallback';

import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import { setUyariAdet } from 'src/utils/storage/NavBarAdet';
import { text } from '../../modules/languages/index';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    minHeight: '100vh',
    padding: theme.spacing(0),
  },
  searchPaper: {
    padding: '4px 12px',
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    borderRadius: 25,
    boxShadow: '0 4px 12px 0 rgba(0,0,0,0.05)',
  },
  searchInput: {
    flex: 1,
    marginLeft: theme.spacing(1),
  },
  card: {
    borderRadius: 16,
    boxShadow: '0 8px 24px rgba(149, 157, 165, 0.2)',
  },
  listItem: {
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    padding: theme.spacing(2),
  },
  avatar: {
    backgroundColor: blueGrey[50],
    color: blueGrey[700],
    marginRight: theme.spacing(1),
  },
  orderInfo: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    fontSize: '0.9rem',
  },
  customerName: {
    fontWeight: 800,
    fontSize: '1.1rem',
    display: 'block',
  },
  metaInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
    flexWrap: 'wrap',
  },
  aramaSayisi: {
    backgroundColor: amber[50],
    color: amber[900],
    fontWeight: 'bold',
    border: `1px solid ${amber[200]}`,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

function Todos({ className }) {
  const classes = useStyles();
  const history = useHistory();
  const [todos, setTodos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [todosData, setTodosData] = useState([]);
  
  const SessionUser = getUser();
  const BirimKodu = SessionUser.ServiceShopId;
  const TeknisyenKodu = SessionUser.TechnicianId;

  const onSearch = (event) => {
    const value = event.target.value.toLowerCase();
    const filtered = todos.filter((item) => 
      item.ACIKLAMA.toLowerCase().includes(value) || 
      item.Musteri.toLowerCase().includes(value) ||
      item.FIS_NO.toString().includes(value)
    );
    setTodosData(filtered);
  };

  useEffect(() => {
    let mounted = true;
    const fetchTodos = async () => {
      try {
        const response = await axios.get(`/GetArtemisTodoList/${BirimKodu}/${TeknisyenKodu}/0/0`);
        if (mounted) {
          const data = response.data || [];
          setTodos(data);
          setTodosData(data);
          setUyariAdet(data.length);
          setLoading(false);
        }
      } catch (error) {
        setUyariAdet(0);
        setLoading(false);
      }
    };
    fetchTodos();
    return () => { mounted = false; };
  }, [BirimKodu, TeknisyenKodu]);

  return (
    <div className={clsx(classes.root, className)}>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>

      {window.navigator.onLine && (
        <Box maxWidth={600} margin="auto">
          {/* Modern Arama Çubuğu */}
          <Paper className={classes.searchPaper} elevation={0}>
            <SearchIcon color="action" />
            <Input
              className={classes.searchInput}
              disableUnderline
              onChange={onSearch}
              placeholder={text("Arama_Yap")}
            />
          </Paper>

          <Card className={classes.card}>
            <CardHeader 
              title="Çağrı Merkezi Uyarıları" 
              titleTypographyProps={{ variant: 'h6', style: { fontWeight: 700 } }}
              avatar={<NotificationsActiveIcon color="primary" />}
            />
            <Divider />
            <CardContent style={{ padding: 0 }}>
              <List disablePadding>
                {todosData.map((log, index) => (
                  <React.Fragment key={log.SM_ID}>
                    <ListItem 
                      button 
                      className={classes.listItem}
                      onClick={() => history.push(`/WorkOrder/${log.FIS_NO}/summary`)}
                    >
                      <ListItemAvatar>
                        <Avatar className={classes.avatar}>
                          <PhoneCallbackIcon fontSize="small" />
                        </Avatar>
                      </ListItemAvatar>
                      
                      <ListItemText
                        primaryTypographyProps={{ component: 'div' }}
                        secondaryTypographyProps={{ component: 'div' }}
                        primary={
                          <Box mb={0.5}>
                            <Typography variant="caption" component="span" className={classes.orderInfo}>
                              {log.FIS_NO}
                            </Typography>
                            <Typography component="span" className={classes.customerName}>
                              {log.Musteri}
                            </Typography>
                          </Box>
                        }
                        secondary={
                          <Box component="span">
                            <Typography variant="body2" component="span" color="textSecondary" style={{ fontStyle: 'italic', marginBottom: 4 }}>
                              {log.BASVURU_NEDENI}
                            </Typography>
                            
                            <Typography variant="body2" component="span" color="textPrimary" style={{ marginBottom: 8 }}>
                              {log.ACIKLAMA}
                            </Typography>

                            <Box className={classes.metaInfo}>
                              <Chip 
                                size="small" 
                                label={`${log.GUN} ${log.AY} ${log.SAAT}`} 
                                color="primary" 
                                variant="outlined" 
                              />
                              <Chip 
                                size="small" 
                                label={`Arama: ${log.ARAMA_SAYISI}`} 
                                className={classes.aramaSayisi} 
                              />
                              <Typography variant="caption" component="span" color="textSecondary">
                                Tel: ({log.ARAYAN_TEL.substring(0, 3)})***{log.ARAYAN_TEL.substring(8, 10)}
                              </Typography>
                            </Box>
                          </Box>
                        }
                      />

                      <ListItemSecondaryAction>
                        {log.OKUNDU && (
                          <CheckCircleIcon style={{ color: green[500] }} />
                        )}
                      </ListItemSecondaryAction>
                    </ListItem>
                    {index < todosData.length - 1 && <Divider component="li" />}
                  </React.Fragment>
                ))}
              </List>
              {todosData.length === 0 && !loading && (
                <Box p={4} textAlign="center">
                  <Typography color="textSecondary">Uyarı bulunamadı.</Typography>
                </Box>
              )}
            </CardContent>
          </Card>
        </Box>
      )}
    </div>
  );
}

Todos.propTypes = {
  className: PropTypes.string
};

export default Todos;